import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { ColumnInstance, Row } from 'react-table';

import { Dropdown } from 'ui/patterns';
import { Button } from 'ui/components';

import { useDeleteLocations } from 'hooks';

import * as Icon from 'assets/icons';

import { confirmAlert } from 'utils/confirm-alert';

import { TableLocationOptions } from './locationListType';

export default function TableOptionsHeader(
  props: TableLocationOptions,
): ReactElement {
  const locId = props.row.original.Id;
  const params = useParams<{
    accountId: string;
  }>();
  const accountId = parseInt(params.accountId);
  const { mutate: deleteLocation } = useDeleteLocations(accountId, locId);

  const locationlistOptions = [
    {
      value: 'Edit Location',
      icon: <Icon.Edit title="Options" />,
      groupEnd: true,
      action: () => props.onEditPress && props.onEditPress(locId),
    },
    {
      value: 'Delete Location',
      icon: <Icon.Delete title="Options" />,
      action: () => handleDeleteLocation(),
    },
  ];

  const handleDeleteLocation = () => {
    confirmAlert({
      message: 'Are you sure you want to delete this location?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            deleteLocation({ locId, accountId });
          },
          className: 'pr-btn-primary',
        },
        {
          label: 'No',
          onClick: () => {
            //
          },
        },
      ],
    });
  };

  const locationlistDropdown = () => (
    <Button size="sm">
      <Icon.DotsVertical title="Options" />
    </Button>
  );

  return (
    <>
      <Dropdown
        trigger={locationlistDropdown()}
        menuList={locationlistOptions}
        position="left-top"
        className="dd-listitem-options"
      />
    </>
  );
}
